// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3s2Jn","col":"styles_col__t_a2t"};